// AlertsHooksMapping.js

import {
  useGetGeofenceAlertQuery,
  useGetIdleAlertQuery,
  useGetOtherAlertQuery,
  useGetPowerCutAlertQuery,
  useGetSosAlertQuery,
  useGetSpeedAlertQuery,
} from "../Redux/service/Alerts/Alerts";

export const AlertsHooksMapping = {
  "Speed Alerts": useGetSpeedAlertQuery,
  "Idle Alerts": useGetIdleAlertQuery,
  "Power Cut": useGetPowerCutAlertQuery,
  "Other Alerts": useGetOtherAlertQuery,
  "Total Alerts": useGetSosAlertQuery,
  "Geofences Alerts": useGetGeofenceAlertQuery,
};
